const WidgetLayout = ({ children }) => {
	return (
		<div>
			{children}
		</div>
	)
}

export default WidgetLayout
